import capitalize from 'utils/capitalize';

export default function humanize(camelCased) {
  const words = camelCased.match(/[A-Za-z][^_\-A-Z]*/g);
  return words.map(capitalize).join(' ');
}
